<template>
  <div class="table-manage relative">
    <slot name="expand"></slot>
    <el-table
      ref="multipleTable"
      :size="size"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ background: 'rgb(254,243,232)', color: '#333333' }"
      :max-height="maxHeight"
      :empty-text="emptyText"
      @selection-change="selectChange"
      :row-key="getSelectedKey"
      :expand-row-keys="expandRowKeys"
      :border="border"
    >
      <el-table-column
        type="expand"
        fixed="left"
        :width="expandWidth"
        v-if="!noExpand"
        label="展开/收起"
      >
        <template slot-scope="scope">
          <slot :row="scope.row" name="expand"></slot>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectable"
        :selectable="selectableFun"
        fixed="left"
        align="center"
        label="展开/收起"
        key="selection"
        type="selection"
        width="100"
      >
      </el-table-column>
      <slot></slot>
    </el-table>
    <!-- v-show="total>page.pageSize" -->
    <el-pagination
      v-show="!noPagination"
      class="pagination"
      :page-size="page.pageSize"
      :current-page="page.pageNum"
      :pager-count="5"
      @size-change="sizeChanged"
      @current-change="currentChanged"
      :page-sizes="[10, 20, 30, 50, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cache: {}, // 所选则缓存容器,所有已选择的数据都存放在这里面
      page: {
        pageNum: 1,
        pageSize: 20,
      },
      total: 0,
      flag: true,
    };
  },
  props: {
    maxHeight: {
      type: [Number, String],
      default: 800,
    },
    value: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: [],
    },
    byKey: {
      type: String,
      default: "id",
    },
    selectableFun: {
      type: Function,
      default: () => ({}),
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    initData: {
      type: Function,
      default: () => ({}),
    },
    noPagination: {
      type: Boolean,
      default: false,
    },
    noExpand: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    // 自定义获取用于多选的唯一标识，默认使用byKey的值
    getCustomSelectedKey: Function,
    size: String,
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    expandWidth: {
      // 展开行的宽度
      type: String,
      default: "100",
    },
  },
  methods: {
    sizeChanged(e) {
      this.init({ pageSize: e });
    },
    async init(params = { pageNum: 1 }) {
      let param = Object.assign({}, this.page, params);
      try {
        let res = await this.initData(param);
        if (res) {
          this.page.pageNum = res.pageNum || 1;
          this.page.pageSize = res.pageSize || 20;
          this.total = res.total || 0;
        }
      } catch (err) {
        console.log(err, "初始化列表异常");
      }
    },
    currentChanged(e) {
      this.init({ pageNum: e });
    },
    computeCache(select, table) {
      // 根据用户的选择计算出切换不同页总共选择的项数并存入缓存，用表格每一行的id名作为缓存的唯一标识
      if (!this.flag) {
        return;
      }
      let selectMap = select.map((i) => this.getSelectedKey(i));
      table.forEach((i) => {
        if (selectMap.includes(this.getSelectedKey(i))) {
          // 这里加这个判断的话会导致已选中的情况下改变tableData时，数据依然是取旧的，而不是改变后的tableData的数据
          // if (!this.cache[this.getSelectedKey(i)]) {
          //   this.cache[this.getSelectedKey(i)] = i
          // }
          this.cache[this.getSelectedKey(i)] = i;
        } else {
          if (this.cache[this.getSelectedKey(i)]) {
            delete this.cache[this.getSelectedKey(i)];
          }
        }
      });
      this.$emit(
        "input",
        Object.keys(this.cache).map((i) => this.cache[i]),
      );
    },
    selectChange(e) {
      this.computeCache(e, this.tableData);
    },
    handChangeBySlectList() {
      // 根据外部传入的已选择的选项手动勾选表格中的多选框
      if (!Array.isArray(this.value)) {
        return;
      }
      this.cache = {};
      let range = this.value.map((i) => {
        this.cache[this.getSelectedKey(i)] = i;
        return this.getSelectedKey(i);
      });
      this.tableData.forEach((item) => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.toggleRowSelection(
            item,
            range.includes(this.getSelectedKey(item)),
          );
        }
      });
    },
    getSelectedKey(item) {
      return this.getCustomSelectedKey
        ? this.getCustomSelectedKey(item)
        : item[this.byKey];
    },
    toggleAllSelection() {
      this.$refs.multipleTable.toggleAllSelection();
    },
  },
  watch: {
    value: {
      handler() {
        this.handChangeBySlectList();
      },
      deep: true,
      immediate: true,
    },
    tableData: {
      handler(e) {
        this.flag = false;
        this.$nextTick((_) => {
          this.flag = true;
          if (this.$refs.multipleTable) {
            e.filter((i) => this.cache[this.getSelectedKey(i)]).forEach((i) => {
              this.$refs.multipleTable.toggleRowSelection(i, false);
              this.$refs.multipleTable.toggleRowSelection(i, true);
            });
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  activated() {
    this.handChangeBySlectList();
  },
};
</script>
<style lang="scss" scoped>
.table-manage {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// tableSelectAll.vue?5228c3de